var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRooftype1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 85,
    viewBox: "0 0 129 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.226 84.0544H86.0822C85.1853 84.0544 84.3251 83.698 83.6909 83.0635C83.0567 82.4291 82.7004 81.5687 82.7004 80.6715V56.128H69.9682L69.8329 80.6545C69.8329 81.5518 69.4766 82.4122 68.8424 83.0466C68.2082 83.681 67.3481 84.0375 66.4512 84.0375H3.38174C2.48485 84.0375 1.62468 83.681 0.990486 83.0466C0.356287 82.4122 0 81.5518 0 80.6545V3.99638C0 3.09916 0.356287 2.23873 0.990486 1.6043C1.62468 0.969872 2.48485 0.613403 3.38174 0.613403H125.226C126.123 0.613403 126.983 0.969872 127.617 1.6043C128.251 2.23873 128.608 3.09916 128.608 3.99638V80.6715C128.608 81.5687 128.251 82.4291 127.617 83.0635C126.983 83.698 126.123 84.0544 125.226 84.0544ZM89.447 77.2885H121.844V7.37935H6.76348V77.2885H63.0863L63.2216 52.7789C63.2216 51.8817 63.5779 51.0211 64.2121 50.3867C64.8463 49.7523 65.7065 49.3959 66.6033 49.3959H86.0822C86.979 49.3959 87.8392 49.7523 88.4734 50.3867C89.1076 51.0211 89.4639 51.8817 89.4639 52.7789L89.447 77.2885Z",
    fill: "#68B544"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooftype1);
export default __webpack_public_path__ + "rooftype_1.3f00b51d.svg";
export { ForwardRef as ReactComponent };